import api from "./client";

/** Reglages > Suivi — synthese d'activite jour par jour (backend /activity/summary). */

export interface RdvDay { date: string; created: number; on_servicebox: number; in_alpha: number }
export interface RdvBacklogItem {
  id: string; num?: string; client_name?: string; immatriculation?: string; status?: string;
  reception_date?: string | null; created_at?: string | null;
  on_servicebox: boolean; in_alpha: boolean; missing: "servicebox" | "alpha";
}
export interface WhatsAppDay {
  date: string; sent: number; delivered: number; read: number; failed: number; inbound: number;
  failed_mobile: number; failed_fixe: number; failed_autre: number; failed_mobile_recovered?: number;
}
export interface ConfirmationDay {
  date: string; asked: number; answered: number; failed: number; pending: number; unanswered: number; unanswered_rate: number;
}
export interface ProxyDay {
  date: string; create_rdv: number; create_rdv_failed: number; transfer_alpha: number; transfer_alpha_failed: number;
  delete_rdv: number; status_push_failed: number; transfer_avg_s: number;
}
export interface DeletionItem {
  ordre_id: string; num?: string; client_name?: string; deleted_at?: string; deleted_by?: string;
  had_servicebox_rdv?: boolean; had_alpha_or?: boolean;
}

export interface ActivitySummary {
  days: string[];
  generated_at: string;
  rdv: { days: RdvDay[]; totals: { created: number; on_servicebox: number; in_alpha: number } };
  rdv_backlog: RdvBacklogItem[];
  whatsapp: { days: WhatsAppDay[]; totals: Record<keyof Omit<WhatsAppDay, "date">, number> };
  whatsapp_failures: {
    by_line: { mobile: number; fixe: number; autre: number };
    reasons_by_line: Record<string, [string, number][]>;
  };
  confirmations: {
    days: ConfirmationDay[];
    totals: { asked: number; failed: number; answered: number; pending: number; unanswered: number; unanswered_rate: number };
  };
  proxy: { days: ProxyDay[]; totals: Record<Exclude<keyof ProxyDay, "date" | "transfer_avg_s">, number> };
  deletions: { days: { date: string; deleted: number }[]; totals: { deleted: number }; recent: DeletionItem[] };
}

export const activityApi = {
  getSummary: async (days = 14): Promise<ActivitySummary> => {
    const { data } = await api.get("/activity/summary", { params: { days } });
    return data;
  },
};
